// extracted by mini-css-extract-plugin
module.exports = {"hyperlink":"EntryPage_hyperlink__1dLR1","centerAlign":"EntryPage_centerAlign__1_QIB"};